import { useState, useEffect } from 'react';
import { Bike, CircleCheck, AlertTriangle } from 'lucide-react';
import { Badge } from './Badge';

function minutesUntil(isoString) {
	return Math.round((new Date(isoString) - Date.now()) / 60000);
}

function dropoffEtaString(dropoffEta) {
	if (!dropoffEta) return null;
	const min = Math.round((new Date(dropoffEta.min) - Date.now()) / 60000);
	const max = Math.round((new Date(dropoffEta.max) - Date.now()) / 60000);
	return `${min}-${max}`;
}

export const WoltBadge = ({ woltMeta, onClick }) => {
	// Dummy tick — we don't use the value, just need a re-render every 30s
	const [, setTick] = useState(0);
	useEffect(() => {
		const id = setInterval(() => setTick(t => t + 1), 30_000);
		return () => clearInterval(id);
	}, []);

	if (!woltMeta) return null;
	const { status, pickupEta, dropoffEta } = woltMeta;

	const pickupMins = pickupEta != null ? minutesUntil(pickupEta) : null;
	const dropoffStr = dropoffEtaString(dropoffEta);

	const getBadge = () => {
		if (status === 'delivered')
			return (
				<Badge variant='green' icon={CircleCheck} tooltip='Παραδόθηκε'>
					Παραδόθηκε
				</Badge>
			);

		if (status === 'customer_no_show')
			return (
				<Badge variant='red' icon={AlertTriangle} tooltip='Ο πελάτης είναι φάντασμα'>
					Πελάτης φάντασμα
				</Badge>
			);

		if (['picked_up', 'dropoff_started', 'dropoff_arrival', 'dropoff_eta_updated'].includes(status))
			return (
				<Badge variant='amber' icon={Bike} tooltip='Προς παράδοση'>
					{dropoffStr ? `Παράδοση σε ~${dropoffStr}λ` : 'Προς παράδοση'}
				</Badge>
			);

		if (pickupMins != null)
			return (
				<Badge variant='blue' icon={Bike} tooltip='Ο διανομέας έρχεται'>
					Driver σε ~{pickupMins}λ
				</Badge>
			);

		return (
			<Badge variant='neutral' tooltip='Η Wolt προσπαθεί να αναθέσει την παραγγελία'>
				Αναζήτηση driver
			</Badge>
		);
	};

	return <div onClick={onClick}>{getBadge()}</div>;
};
